import React from 'react';
import {Button, Modal, ModalBody, ModalFooter, ModalHeader, Row, Table,} from 'reactstrap';
import BaseComponent from '../BaseComponent';
import Checkbox from '../../components/Checkbox';
import PropTypes from 'prop-types';
import ModalPagination from '../ModalPagination';
// import label, {GENDERS} from '../../message/Label';
import label from 'enqc-utilities/src/label/Label'
import Endpoint from "enqc-utilities/src/api/Endpoint";
import {parseDate} from "../../utils/Utilities";
import {DD_MMMM_YYYY_HH_MM_SS} from "../../utils/Global";
import ModalCardHeader from "../Widget/ModalCardHeader";

/*= (message, okCallback, cancelCallback) =>*/
export default class ComponentSelectionModal extends BaseComponent{

    componentGroups = new Array()
    componentGroup = new Object();

    constructor(props){
        super(props);
        let state = this.state
        state.backdrop = false
        state.showing = this.props.showing
        state.componentGroups = this.componentGroups
        state.componentGroup = this.props.componentGroup?this.props.componentGroup:this.componentGroup
        state.page = 1
        state.sortir = "created"
        state.ascending = true

        this.setState(state)
        this.buttonClick = this.buttonClick.bind(this)
    }

    componentWillReceiveProps(props, nextContext) {
        let showing = this.state.showing
        if(this.props!=props){
            this.setState({
                showing:props.showing,
                componentGroup : props.componentGroup?props.componentGroup:this.componentGroup
            }, () => {
                if(props.showing && props.showing!==showing) {
                    this.fetchComponentGroups()
                }
            })
        }
    }

    fetchComponentGroups = () =>{
        let componentGroup = this.state.componentGroup

        this.get(Endpoint.API.COMPONENT_GROUPS, {
            params:{
                page:this.state.page-1,
                ascending:this.state.ascending,
                sortir: this.state.sortir,
                search:this.state.search,
            }
        }, null, response=>{
            if(response.code===200){
                let componentGroups = response.data
                if(componentGroup){
                    componentGroups.forEach((value, index) => {
                        if(componentGroup[componentGroups[index].id]){
                            componentGroups[index].checked = true
                        }else{
                            componentGroups[index].false = true
                        }
                    })
                    this.setState({componentGroups:componentGroups})
                }
                this.setState({
                    componentGroups:componentGroups,
                    totalPage: response.totalPage,
                    totalElement: response.totalElement,
                    pageElement: response.pageElement,
                })
            }
        }, true, true)
    }

    buttonClick (e, button){
        e.preventDefault()
        if(button===label.Ok){
            if(this.props.okCallback!=null){
                this.props.okCallback()
            }
        }else{
            if(this.props.cancelCallback!=null){
                this.props.cancelCallback()
            }
        }
    }

    close = () =>{
        this.setState({
            componentGroup:{},
            componentGroups:[],
            showing: false,
        }, () => {
            this.props.cancelCallback()
        })
    }

    render(){
        let componentGroup = this.state.componentGroup ;
        let componentGroups = this.state.componentGroups ;
        let page =  this.state.page
        let totalPage =  this.state.totalPage
        let totalElement =  this.state.totalElement
        let pageElement =  this.state.pageElement

        return (
            /*xl-lg-sm*/
            <Modal
                size="xl"
                style={{minWidth:'65%'}}
                className="border-primary"
                centered={true}
                isOpen={this.state.showing}
                backdrop={true}
                zIndex="1">
                {super.render()}
                <ModalCardHeader content={label.ComponentGroups}/>
                <ModalBody>
                    <Row>
                        <Table responsive hover>
                            <thead>
                            <tr>
                                <th>#</th>
                                <th>{label.Label}</th>
                                <th>{label.Description}</th>
                                <th>{label.Created}</th>
                                <th>{label.Check}</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                componentGroups.map((item, index)=>(
                                    <tr valign="center" key={index}>
                                        <th scope="row">{++index}</th>
                                        <td>{item.label}</td>
                                        <td>{item.description}</td>
                                        <td>{parseDate(item.created, DD_MMMM_YYYY_HH_MM_SS)}</td>
                                        <td>
                                            <Checkbox
                                                checked={item.id===componentGroup.id}
                                                onChange={
                                                checked => {
                                                    if(checked){
                                                        componentGroup = item
                                                    }else{
                                                        componentGroup = {}
                                                    }
                                                    this.setState({componentGroup})
                                                }
                                            }/></td>
                                    </tr>
                                ))
                            }
                            </tbody>
                        </Table>
                    </Row>
                </ModalBody>
                <ModalPagination {...this.props} currentPage={page} pageCount={totalPage} onSelect={(page)=>{
                    this.setState({
                        page:page
                    }, () => {
                        this.fetchComponentGroups()
                    })
                }}/>
                <ModalFooter>
                    <Button color="secondary" onClick={e=>{
                        e.preventDefault()
                        if(this.props.cancelCallback){
                            this.props.cancelCallback()
                        }
                        this.close()
                    }}>
                        {label.Cancel}
                    </Button>
                    <Button color="primary" onClick={e=>{
                        e.preventDefault()
                        if(this.props.okCallback){
                            this.props.okCallback(componentGroup)
                        }
                        this.close()
                    }}>
                        {label.Update}
                    </Button>
                </ModalFooter>
            </Modal>
        )
    }
}

ComponentSelectionModal.propTypes = {
    componentGroup : PropTypes.any,
    showing : PropTypes.bool.isRequired,
    okCallback : PropTypes.func,
    cancelCallback : PropTypes.func
}
